import { FormControl, FormHelperText, TextareaAutosize } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import useStyles from './CustomTextAreaStyles';
var CustomTextArea = function (_a) {
    var _b;
    var dataTestId = _a.dataTestId, minRows = _a.minRows, maxRows = _a.maxRows, placeholder = _a.placeholder, value = _a.value, onBlur = _a.onBlur, onChange = _a.onChange, errors = _a.errors, touched = _a.touched, name = _a.name, disabled = _a.disabled, className = _a.className, fullWidth = _a.fullWidth, maxLength = _a.maxLength;
    var styles = useStyles();
    return (React.createElement(FormControl, { variant: "outlined", className: className, disabled: disabled, error: touched && Boolean(errors), fullWidth: fullWidth },
        React.createElement(TextareaAutosize, { id: name, className: clsx(styles.textArea, (_b = {},
                _b[styles.textAreaError] = touched && Boolean(errors),
                _b)), name: name, value: value, onChange: onChange, onBlur: onBlur, minRows: minRows, maxRows: maxRows, placeholder: placeholder, "data-testid": dataTestId, maxLength: maxLength }),
        touched && Boolean(errors) ? React.createElement(FormHelperText, null, errors) : null));
};
CustomTextArea.defaultProps = {
    className: '',
    placeholder: '',
    disabled: false,
    errors: undefined,
    touched: undefined,
    fullWidth: true,
    maxLength: undefined,
};
export default CustomTextArea;
